import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './LegalPage.css';

/**
 * Renders a legal document page (Privacy Policy or Terms of Use).
 * Title and body come from locale; body is rendered as HTML (break lines and paragraphs from JSON).
 */
const LegalPage = ({ titleKey, contentKey }) => {
  const { t } = useTranslation();
  const title = t(titleKey);
  const content = t(contentKey);

  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="legal-back">
          ← {t('backToHome', 'Back to Home')}
        </Link>
        <article className="legal-article" role="main">
          <h1 className="legal-title">{title}</h1>
          <div
            className="legal-content"
            dangerouslySetInnerHTML={{ __html: content || '' }}
          />
        </article>
      </div>
    </div>
  );
};

export default LegalPage;
